import script from "./BannerComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BannerComponent.vue?vue&type=script&lang=ts&setup=true"

import "./BannerComponent.vue?vue&type=style&index=0&id=9b8a5cee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b8a5cee"]])

export default __exports__